<template>
  <v-container>
    <v-col>
      <!-- header start -->
      <v-row class="mb-5">
        <header class="header">
          <div @click="toIndex" style="cursor: pointer">
            <v-avatar class="mr-3">
              <img src="https://microsteel.cn/img/logo.png" alt="logo" />
            </v-avatar>
            <span style="font-weight: bold">微钢供应商服务平台</span>
          </div>
        </header>
      </v-row>
      <!-- header end -->
      <v-row>
        <v-stepper style="width: 100%" v-model="el">
          <!-- 步骤条 start -->
          <v-stepper-header>
            <v-stepper-step color="success" :complete="el > 1" step="1">填写基本信息</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step color="success" :complete="el > 2" step="2">填写文件信息</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step color="success" :complete="el > 2" step="3">提交成功</v-stepper-step>
          </v-stepper-header>
          <!-- 步骤条 end -->
          <v-stepper-items>
            <!-- 步骤一 start -->
            <v-stepper-content step="1">
              <v-row justify="center" class="mt-6">
                <v-col cols="12" sm="10" md="8" lg="6">
                  <v-card ref="form">
                    <step-one></step-one>
                    <v-divider class="mt-6"></v-divider>
                    <v-card-actions
                      style="display: flex; justify-content: center; align-item: center"
                    >
                      <v-btn color="success" style="width: 50%" raised large @click="el = 2">下一步</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- 步骤一 end -->
            <!-- 步骤二 start -->
            <v-stepper-content step="2">
              <v-row justify="center" class="mt-6">
                <v-col cols="12" sm="10" md="8" lg="6">
                  <v-card ref="form">
                    <step-two></step-two>
                    <v-divider class="mt-6"></v-divider>
                    <v-card-actions
                      style="display: flex; justify-content: center; align-item: center"
                    >
                      <v-btn color="error" style="width: 30%" raised large @click="el = 1">返回</v-btn>
                      <v-btn color="success" style="width: 30%" raised large @click="el = 3">下一步</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- 步骤二 end -->
            <!-- 步骤三 start -->
            <v-stepper-content step="3">
              <v-row justify="center" class="mt-6">
                <v-col cols="12" sm="10" md="8" lg="6">
                  <v-card ref="form">
                    <step-three></step-three>
                    <v-divider class="mt-6"></v-divider>
                    <v-card-actions
                      style="display: flex; justify-content: center; align-item: center"
                    >
                      <v-btn color="success" style="width: 30%" raised large @click="$router.push('/')">返回首页</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- 步骤三 end -->
          </v-stepper-items>
        </v-stepper>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import stepOne from "./stepOne";
import stepTwo from "./stepTwo";
import stepThree from "./stepThree";

export default {
  components: {
    stepOne,
    stepTwo,
    stepThree
  },
  data: () => {
    return {
      linkList: [
        // 面包屑导航列表
        {
          text: "首页",
          disabled: false,
          href: "/"
        },
        {
          text: "注册",
          disabled: true
        }
      ],
      el: 1 // 步骤条步数控制
    };
  },
  methods: {
    toIndex() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>